//@ts-check
import createBatchAction from '@/common/lib/create-batch-action';
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import { updateResult } from '../result/result.action';
import { STATUS_FAILURE_UP_NOAUTH } from '@/common/constants';
import { initEntity } from '@/common/lib/entity-module';

export const changeRequestRequest = createBatchAction('@@password/CHANGE_REQUEST_REQUEST', () => [showLoading()]);
export const changeRequestSuccess = createBatchAction('@@password/CHANGE_REQUEST_SUCCESS', () => [hideLoading(), initEntity({ target: 'errMsgPassword', data: '' })]);
export const changeRequestFailure = createBatchAction('@@password/CHANGE_REQUEST_FAILURE', (err) => [
  hideLoading(),
  changeRequestNgHandler(err),
]);

const changeRequestNgHandler = (e) => {
  switch (e?.status) {
    case STATUS_FAILURE_UP_NOAUTH:
      return initEntity({ target: 'errMsgPassword', data: '電話番号の登録がありません' });
    default:
      return initEntity({ target: 'errMsgPassword', data: 'パスワードの設定に失敗しました' });
  }
};

export const clearPasswordRequest = createBatchAction('@@password/CLEAR_PASSWORD_REQUEST', () => [showLoading()]);
export const clearPasswordSuccess = createBatchAction('@@password/CLEAR_PASSWORD_SUCCESS', () => [hideLoading(), initEntity({ target: 'errMsgPassword', data: '' })]);
export const clearPasswordFailure = createBatchAction('@@password/CLEAR_PASSWORD_FAILURE', (err) => [
  hideLoading(),
  clearPasswordNgHandler(err)
]);

const clearPasswordNgHandler = (e) => {
  switch (e?.status) {
    case STATUS_FAILURE_UP_NOAUTH:
      return initEntity({ target: 'errMsgPassword', data: '電話番号の登録がありません' });
    default:
      return initEntity({ target: 'errMsgPassword', data: 'パスワードの設定に失敗しました' });
  }
};

export const clearPasswordNextRequest = createBatchAction('@@password/CLEAR_PASSWORD_NEXT_REQUEST', () => [showLoading()]);
export const clearPasswordNextSuccess = createBatchAction('@@password/CLEAR_PASSWORD_NEXT_SUCCESS', () => [hideLoading(), initEntity({ target: 'errMsgPassword', data: '' })]);
export const clearPasswordNextFailure = createBatchAction('@@password/CLEAR_PASSWORD_NEXT_FAILURE', (err) => [
  hideLoading(),
  clearPasswordNextNgHandler(err)
]);

const clearPasswordNextNgHandler = (e) => {
  switch (e?.status) {
    case STATUS_FAILURE_UP_NOAUTH:
      return initEntity({ target: 'errMsgPassword', data: '電話番号の登録がありません' });
    default:
      return initEntity({ target: 'errMsgPassword', data: 'パスワードの設定に失敗しました' });
  }
};

export const setPasswordRequest = createBatchAction('@@password/SET_PASSWORD_REQUEST', () => [showLoading()]);
export const setPasswordSuccess = createBatchAction('@@password/SET_PASSWORD_SUCCESS', () => [
  hideLoading(),
  initEntity({ target: 'errMsgPassword', data: '' }),
  updateResult('パスワードの設定が完了しました。')]);
export const setPasswordFailure = createBatchAction('@@password/SET_PASSWORD_FAILURE', (err) => [
  hideLoading(),
  setPasswordNgHandler(err)
]);

const setPasswordNgHandler = (e) => {
  switch (e?.status) {
    default:
      return initEntity({ target: 'errMsgPassword', data: 'パスワードの設定に失敗しました' });
  }
};